import { clsx } from 'clsx';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from 'src/components/ui/accordion';
import React from 'react';
import { ExpandCollapseIcon } from 'src/pages/ProjectPage/CreateProjectSteps/ExpandCollapseIcon/ExpandCollapseIcon';
import { UsedExistingKBAccordionItem } from 'src/pages/ProjectPage/CreateProjectSteps/CreateProjectStep2Page/UseExistingKBAccordion/UseExistingKBAccordionItem';
import { Skeleton } from 'src/components/ui/skeleton';

const EmptySkeleton = () => {
  return (
    <div className={'w-full flex flex-col gap-5'}>
      <Skeleton className={'w-full h-6'}></Skeleton>
      <Skeleton className={'w-full h-60'}></Skeleton>
    </div>
  );
};

export const UseExistingKBAccordion = ({ items = [] }) => {
  const disabled = !items.length;
  const [value, setValue] = React.useState('existed-kb');

  return (
    <div className={'w-full flex flex-row items-start gap-5'}>
      {disabled ? (
        <EmptySkeleton />
      ) : (
        <Accordion
          value={value}
          onValueChange={setValue}
          type="single"
          className="w-full"
          collapsible={true}
          disabled={disabled}
        >
          <AccordionItem
            value="existed-kb"
            className={clsx(
              'group rounded-sm-5 border-0 transition-shadow shadow-none hover:!shadow-none',
              !disabled && 'hover:shadow-[0_2px_2px_rgba(0,0,0,0.25)]',
              disabled && 'opacity-70',
            )}
          >
            <AccordionTrigger hideDefaultIcon className="py-2.5 px-0 group/trigger">
              <div className="flex items-center justify-between w-full">
                <div
                  className={
                    'flex flex-row gap-[7px] text-violet font-semibold text-sm group-hover/trigger:underline'
                  }
                >
                  <p>Use existing knowledge base</p>
                </div>
                <ExpandCollapseIcon expanded={value === 'existed-kb'} />
              </div>
            </AccordionTrigger>
            <AccordionContent className="px-0 pb-0 mt-4 max-h-[400px] overflow-auto">
              <div className={'flex flex-col gap-1.5'}>
                {items.map((item) => {
                  return <UsedExistingKBAccordionItem key={`item-${item.id}`} item={item} />;
                })}
              </div>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      )}
    </div>
  );
};
